import PropTypes from 'prop-types';
import React from 'react';
import {connectToStores} from 'fluxible-addons-react';
import FontAwesome from 'react-fontawesome';
import {addFavorite, removeFavorite} from '../actions/CommonActionCreators';
import classnames from 'classnames';

@connectToStores(['FavoriteStore'],
  (context, props) => {
    const FavoriteStore = context.getStore('FavoriteStore');
    const favorite = FavoriteStore.isFavorite(props.url);

    return {
      favorite
    };
  }
)
class FavoriteButton extends React.PureComponent {
  static propTypes = {
    url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    favorite: PropTypes.bool,
    description: PropTypes.string
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  render() {
    const { favorite, url, name, description } = this.props;

    const favoriteClicked = (event) => {
      console.info('favorite clicked', url);
      event.preventDefault();
      const action = favorite ? removeFavorite : addFavorite;
      this.context.executeAction(action, {
        url: url,
        name,
        description
      });
    };

    const favoriteIcon = favorite ? 'star' : 'star-o';
    const favoriteClasses = classnames({
      favorite: true,
      action: true,
      'action-star': true
    });

    return <button className={ favoriteClasses } onClick={ favoriteClicked }>
      <FontAwesome name={ favoriteIcon }/>
    </button>;
  }
}

export default FavoriteButton;



// WEBPACK FOOTER //
// ./src/components/FavoriteButton.js